import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: 0,
  notificationCount: 0,
  currentMenu: "",
  collapsed: false,
  offerList: [],
};

const navCounts = createSlice({
  name: "navCounts",
  initialState,
  reducers: {
    setCounts: (state, action) => {
      const { cartItems, notificationCount } = action.payload;
      if (cartItems !== undefined) state.cartItems = cartItems;
      if (notificationCount !== undefined) state.notificationCount = notificationCount;
    },
    changeCurrentMenu: (state, action) => {
      state.currentMenu = action.payload;
    },
    resetNavState: () => initialState,
    setCollapsedSide: (state, action) => {
      state.collapsed = action.payload;
    },
    setOfferList: (state, action) => {
      state.offerList = action.payload;
    },
  },
});

export const { setCounts, resetNavState, changeCurrentMenu, setCollapsedSide, setOfferList } =
  navCounts.actions;
export default navCounts.reducer;
